export const CheckIcon = () => (
	<svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
		<path
			d='M20 6L9 17l-5-5'
			stroke='currentColor'
			strokeWidth='2.2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const ErrorIcon = () => (
	<svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
		<circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='2' />
		<path
			d='M9 9l6 6M15 9l-6 6'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
		/>
	</svg>
);
